import { DataService } from '../dataService';
export const adminBookService = {
    getBookListApi: (data) => {
        return DataService.get("/book/manage", data)
    }
}